import { graphConfig } from "../Config/EntraAuthConfig";
import { useAuth } from "../Context/AuthContext";

export const useEntra = () => {
    const { accessToken } = useAuth();

    const getUserPhoto = async () => {
        try {
            const response = await fetch(`${graphConfig.graphMeEndpoint}/photo/$value`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) return false;
            const blob = await response.blob();
            return URL.createObjectURL(blob);


        } catch (error) {
            console.error("Error fetching userphoto:", error);
            throw error;
        }
    };

    const getUserProfile = async () => {
        try {
            const response = await fetch(`${graphConfig.graphMeEndpoint}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) throw new Error(`Failed to fetch profile: ${response.status}`);
            const data = await response.json();
            return data;

        } catch (error) {
            console.error("Error fetching user profile:", error);
            throw error;
        }
    };

    return { getUserPhoto, getUserProfile };
};